import { SrciLogicSdkImpl } from "./core/SrciLogicSdk";
var srciLogicSdk = new SrciLogicSdkImpl();
export default srciLogicSdk;
